import React, { FunctionComponent } from 'react'
import { connect } from 'react-redux'
import { CenterPanel } from 'view/routes/routesLayout'
import { TradingControlHeroPanel } from './TradingControlHeroPanel'
import { TradingControlGrid } from './TradingControlGrid'
import { createStructuredSelector } from 'reselect'
import { canManageTradingControlLimitSelector } from 'selectors/permissionSelectors'
import { TradingControlViewHeroPanel } from './TradingControlViewHeroPanel'
import { TradingControlView } from './TradingControlView'
import { canOrganisationViewTradingControlLimitSelector } from 'selectors/tradingControlSelectors'

interface TradingControlScreenProps {
  canManageTradingControlLimit: boolean
  canOrganisationViewTradingControlLimit: boolean
}

const mapStateToProps = createStructuredSelector({
  canManageTradingControlLimit: canManageTradingControlLimitSelector,
  canOrganisationViewTradingControlLimit: canOrganisationViewTradingControlLimitSelector
})

const TradingControlScreenComponent: FunctionComponent<TradingControlScreenProps> = ({
  canManageTradingControlLimit,
  canOrganisationViewTradingControlLimit
}) => {
  if (canManageTradingControlLimit) {
    return (
      <CenterPanel>
        <TradingControlHeroPanel />
        <TradingControlGrid />
      </CenterPanel>
    )
  }

  if (canOrganisationViewTradingControlLimit) {
    return (
      <CenterPanel>
        <TradingControlViewHeroPanel />
        <TradingControlView />
      </CenterPanel>
    )
  }

  return null
}

export const TradingControlScreen = connect(mapStateToProps, {})(TradingControlScreenComponent)
